<template>
  <div class="add-switch-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="落地页模版:" prop="templet">
          <el-input v-model="params.templet" size="small" placeholder="请输入落地页模版"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      flag: false,
      params: {
        id: "",
        templet: "",
        buttons: [],
      },
      rules: {},
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          this.editTemplet();
        } else {
          return false;
        }
      });
    },
    editTemplet() {
      API.updateLdy(this.params).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.$emit("handlerSwitch");
        } else {
          this.$message.error("添加失败,请重试");
        }
        this.handleClose();
        this.flag = false;
      });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params.id = "";
      this.params.templet = "";
      this.$refs.form.resetFields();
    },
    open(param) {
      this.dialogVisible = true;
      this.title = "编辑落地页模版";
      this.params.buttons = param.buttons;
      this.params.id = param.id;
      this.params.templet = param.templet;
    },
  },
};
</script>

<style lang="scss" >
.add-switch-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
